import React, { useMemo } from "react";
import type { CommonFinanceInfoType, PriceType } from "../../../../../../../common-deprecated/types/CommonTypes";
import type { BuildAndBuyDispatchType } from "../../../../redux/store";
import { useBnbSelector } from "../../../../redux/store";
import * as Tooltip from "../../../../../../../common-deprecated/styles/v2/lexus/components/Tooltip";
import { IconWrapper } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import { showModal } from "../../../../../../../common-deprecated/redux/actions/ModalActions";
import { MODAL_FINANCE_DISCLAIMER } from "../../../../../../../common-deprecated/utils/modalConstants";
import { formatMonthlyFinancePrice } from "../../../../../../shared-logic/utils/priceUtils";
import Icon from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { useDispatch } from "../../../../../../../shared-logic/redux/store";

type MonthlyRateDisclaimerType = {
    price: PriceType;
    priceFormat: string;
    financeInfo: CommonFinanceInfoType;
    forceMonthlyDisclaimer?: boolean;
};

// Render a monthly price.
const MonthlyRateDisclaimer = (props: MonthlyRateDisclaimerType): JSX.Element | null => {
    const { price, priceFormat, financeInfo, forceMonthlyDisclaimer } = props;
    const dispatch = useDispatch<BuildAndBuyDispatchType>();

    // showMonthlyRateDisclaimerInline is used to render the price disclaimer under the Price component instead of in a modal.
    // This implies that if showDisclaimerInline is true this component should not render a disclaimer.
    const showDisclaimerInline = useBnbSelector((state) => state.bnbSettings.showMonthlyRateDisclaimerInline);

    const commonSettings = useBnbSelector((state) => state.commonSettings);

    // Retrieve monthly price labels.
    const monthlyRateItems = formatMonthlyFinancePrice(price, financeInfo, commonSettings, priceFormat, price.monthly);

    // Only show the disclaimer label if we have one.
    // Also take into account if the label is not already shown inline with showDisclaimerInline.
    const showMonthlyPriceDisclaimer =
        (!!monthlyRateItems.disclaimer || forceMonthlyDisclaimer) && !showDisclaimerInline;
    const disclaimerSplit = showMonthlyPriceDisclaimer ? monthlyRateItems.disclaimer.split("{icon}") : "";

    return useMemo(
        () =>
            showMonthlyPriceDisclaimer ? (
                <Tooltip.TooltipButton
                    type="button"
                    isSmall
                    onClick={(event) => {
                        event.stopPropagation();
                        dispatch(
                            showModal({
                                type: MODAL_FINANCE_DISCLAIMER,
                                disclaimer: financeInfo.disclaimer!,
                                productName: financeInfo.productName || "",
                            }),
                        );
                    }}
                >
                    {disclaimerSplit[0] && <span dangerouslySetInnerHTML={{ __html: disclaimerSplit[0] }} />}
                    {disclaimerSplit.length > 1 && (
                        <IconWrapper size="lg" aria-hidden="true">
                            <Icon variant="info" />
                        </IconWrapper>
                    )}
                    {disclaimerSplit.length > 1 && <span dangerouslySetInnerHTML={{ __html: disclaimerSplit[1] }} />}
                </Tooltip.TooltipButton>
            ) : null,
        [disclaimerSplit, financeInfo.disclaimer, showMonthlyPriceDisclaimer],
    );
};

export default MonthlyRateDisclaimer;
